"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmphasisSpan = void 0;
const styles_1 = require("../../styles");
exports.EmphasisSpan = (0, styles_1.styled)('span') `
    font-style: italic;
    font-weight: 600;
`;
//# sourceMappingURL=emphasis_span.js.map